import { css, Global, withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { tooltipCss } from '@chronos/components/Tooltip/styled';
import { WorklogsList } from '@chronos/components/WorklogsList/styled';

import 'normalize.css';
import 'rc-collapse/assets/index.css';

const getGlobalStyles = (theme) => css`
  html,
  body {
    width: 100%;
    height: 100%;
  }
  input::-ms-clear,
  input::-ms-reveal {
    display: none;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :root {
    --app-height: 100%;
  }

  html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  body,
  button,
  html,
  input,
  select,
  textarea {
    color: ${theme.colors.primary};
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
      'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
    line-height: 1.5715;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-variant: tabular-nums;
    font-feature-settings: 'tnum';
  }

  // body {
  //   margin: 0;
  //   background-color: ${theme.bgColors.primary};
  // }

  a {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #40a9ff;
    }
    &:active {
      color: #096dd9;
    }
    &:active,
    &:hover {
      text-decoration: none;
      outline: 0;
    }
    &:focus {
      text-decoration: none;
      outline: 0;
    }
    &[disabled] {
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
    }
  }
  a,
  area,
  button,
  [role='button'],
  input:not([type='range']),
  label,
  select,
  summary,
  textarea {
    touch-action: manipulation;
  }

  ${tooltipCss}
`;

export const WorklogsListContainer = styled.div`
  flex: 1;
  height: 100%;

  ${WorklogsList} {
    // crutch for scroll
    > div > div {
      padding: 10px 10px 40px 10px;

      > div {
        position: relative;
      }
    }
  }
`;

const GlobalStyles = ({ theme }) => <Global styles={getGlobalStyles(theme)} />;
export default withTheme(GlobalStyles);
